import { Brand, createBranded } from '@deltasierra/type-utilities';

export type PublishMediaId = Brand<
    number,
    'PublishMediaId'
>;
export const PublishMediaId =
    createBranded<PublishMediaId>();
